<template>
	<THeader />
	<main>
		<Banner id="home" />
		<QuotationComponent />
		<ValueSection id="vantagens" />
		<About id="sobre" />
		<HistorySection id="como-obter" />
    <BlogComponent id="blog" />
		<TestimonialsSection id="depoimentos" />
		<FaqSection id="faq" />
		<WhatsappBubble />
	</main>
	<TFooter />
</template>
<script>
import { useHead } from "@vueuse/head"
import { trackTiktokEvent } from "@/composables/useTiktokEvent"

import THeader from "@/components/Header.vue"
import TFooter from "@/components/Footer.vue"
import Banner from "@/components/Banner.vue"
import QuotationComponent from "@/components/Quotation.vue"

import ValueSection from "@/sections/ValueSection.vue"
import About from "@/sections/About.vue"
import HistorySection from "@/sections/HistorySection.vue"
import TestimonialsSection from "@/sections/TestimonialsSection.vue"
import FaqSection from "@/sections/FaqSection.vue"
import WhatsappBubble from "@/components/WhatsappBubble.vue"
import BlogComponent from './sections/Blog.vue'

export default {
	name: "App",
	setup() {
		useHead({
			title: "Antecipação de FGTS",
			meta: [
				{
					name: "description",
					content: "Antecipe seu FGTS com as melhores condições. Na Vip, a antecipação de FGTS é feita com agilidade e segurança."
				}
			]
		})
	},
	components: {
		THeader,
		TFooter,
		Banner,
		QuotationComponent,
		ValueSection,
		About,
		HistorySection,
		TestimonialsSection,
		BlogComponent,
		FaqSection,
		WhatsappBubble,
	},
	mounted() {
		trackTiktokEvent('PageView')
	},
}
</script>
